module.exports = __webpack_public_path__ + "img/blankscreen_300.cce090cb.png";